import axios from 'axios';

const getList = params => axios.get('/centro-custos', {
  params,
});
const get = id => axios.get(`/centro-custos/${id}`, {});

const save = (centroCusto) => {
  if (centroCusto.id) {
    return axios.put(`/centro-custos/${centroCusto.id}`, centroCusto);
  }
  return axios.post('/centro-custos', centroCusto);
};

const remover = id => axios.delete(`/centro-custos/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
